module.exports = __webpack_public_path__ + "src/assets/img/ramblerkassa.0c9b34b1.jpg";